import { noop } from 'lodash';
import type { Context } from 'react';
import { createContext, useContext } from 'react';

export interface HostContextOptions {
  readonly suggestionListId: string | undefined;
  setIsLoading(): void;
  setIsOpen(itemId?: string): void;
  setIsClosed(): void;
}

const defaultHostContextOptions: HostContextOptions = {
  suggestionListId: undefined,
  setIsLoading: noop,
  setIsOpen: noop,
  setIsClosed: noop,
};

export const HostContext: Context<HostContextOptions> = createContext<HostContextOptions>(defaultHostContextOptions);

export type UseHostContext = () => HostContextOptions;
export const useHostContext: UseHostContext = () => useContext(HostContext);

type UseAutocompleteCalloutId = () => string | undefined;
export const useAutocompleteSuggestionListId: UseAutocompleteCalloutId = () => useHostContext().suggestionListId;

type ElementIdFromSuggestionListAndItemId = (suggestionListId: string, itemId: string) => string;
export const elementIdFromSuggestionListAndItemId: ElementIdFromSuggestionListAndItemId = (suggestionListId, itemId) =>
  `${suggestionListId}-${itemId}`;

type UseAutocompleteItemElementId = (itemId: string) => string | undefined;
export const useAutocompleteItemElementId: UseAutocompleteItemElementId = (itemId) => {
  const suggestionListId = useHostContext().suggestionListId;

  return suggestionListId ? elementIdFromSuggestionListAndItemId(suggestionListId, itemId) : undefined;
};
